import { render, staticRenderFns } from "./Needfb.vue?vue&type=template&id=97657584&scoped=true"
import script from "./Needfb.vue?vue&type=script&lang=js"
export * from "./Needfb.vue?vue&type=script&lang=js"
import style0 from "./Needfb.vue?vue&type=style&index=0&id=97657584&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97657584",
  null
  
)

export default component.exports